<template>
    <el-breadcrumb separator="/" class="breadcrumb">
          <el-breadcrumb-item :to="{ path: '/service' }">认证服务</el-breadcrumb-item>
          <el-breadcrumb-item v-if="pageId!==undefined" :to="serviceMenu[pageId].link">{{ serviceMenu[pageId].name }}</el-breadcrumb-item>
          <el-breadcrumb-item :to="item.link || ''" v-for="(item, index) in list" :key="index">{{ item.title }}</el-breadcrumb-item>
    </el-breadcrumb> 
</template>
<script>
import { serviceMenu } from "@/utils/const.js";
export default {
    props: ['list'],
    data() {
        return {
            pageId: this.$route.query.id,
            serviceMenu
        }
    },
    created(){
    },
    mounted(){
    },
    methods: {
    },
    watch: {
        $route() {
            this.pageId = this.$route.query.id;
        }
    },
}

</script>
<style lang="less" scoped>
.breadcrumb{
    color: #666666;
    line-height: 20px;
    margin-top: 20px;
    ::v-deep{
        .el-breadcrumb__inner a:hover, .el-breadcrumb__inner.is-link:hover{
            color: #DA5351;
        }
    }
}

@media screen and (max-width: 960px){
    .breadcrumb{
        display: none;
    }
}
</style>